











































































































































































































































































































import DataTable from '../../components/DataTable.vue';
import Menu from '@/components/Menu.vue';
import {Component, Vue} from 'vue-property-decorator';
import AddRideCreditProfileModal from './AddRideCreditProfileModal.vue';
import {MedTransGoConstants} from '@/util/constants';
import {ObjectFactory} from '@/config/objectFactory';
import {Address, ApiRequest, AssignRideCreditRequest, QueryRecordsRequest, UpdateOrgRequest} from '@/types/request';
import PurchaseCreditsModal from './PurchaseCreditsModal.vue';
import ViewRideCreditModal from './ViewRideCreditModal.vue';
import {
  Organization,
  OrganizationRideCreditBalance,
  PurchaseHistory,
  RideCreditMethod,
  RideCreditProfile,
} from '@/types/entity';
import {CommonUtils} from '@/util/commonUtils';
import {MemberProfile} from '@/types/response';
import {ToastEvent} from '@/types/event';
import {EventBus} from '@/main';
import {MathUtils} from '@/util/mathUtils';
import {MapUtils} from '@/util/mapUtils';
import ChangePaymentModal from './ChangePaymentModal.vue';
import AddPaymentModal from './AddPaymentModal.vue'; // tslint:disable-next-line: no-var-requires
// tslint:disable-next-line: no-var-requires
const StandardPatientPassTable = require('../../datatable/StandardPatientPassTable.json');
// tslint:disable-next-line: no-var-requires
const PrePaymentPatientPassTable = require('../../datatable/PrePaymentPatientPassTable.json');
// tslint:disable-next-line:no-var-requires
const RideCreditHistoryDatatable = require('../../datatable/RideCreditActivityLog.json');
declare var google: any;


@Component({
    data() {
        return {
            header: 'Patient Pass Management',
            options: [
                {
                    url: 'rideCredit?patientDetails=Patient',
                    activeConditions: {
                        patientDetails: 'Patient',
                    },
                    label: 'Pass Profiles',
                },
                {
                    url: 'rideCredit?patientDetails=subscriptionDetails',
                    activeConditions: {
                        patientDetails: 'subscriptionDetails',
                    },
                    label: 'Activity Log',
                },
            ],
            isCreateProfileModalVisible: false,
            showAssignCreditModal: false,
            assignCredits: 0,
            showSelectRideCreditMethod: false,
            selectedRideCreditMethod: '',
            showChangePaymentForm: false,
            showAddPaymentForm: false,
            replenishmentThreshold: undefined,
            replenishmentAmount: undefined,
            selectedPaymentMethod: undefined,
            isAutoReplenishmentEnabled: false,
            showDisableReplenishmentConfirmation: false,
            enableAotoReplanizhmentError: '',
        };
    },
    components: {
        DataTable,
        Menu,
        AddRideCreditProfileModal,
        PurchaseCreditsModal,
        ViewRideCreditModal,
        ChangePaymentModal,
        AddPaymentModal,
    },
})

export default class RideCreditManagement extends Vue {
    private show = false;
    private patientCreditDataSource: any = StandardPatientPassTable;
    private isCreateProfileModalVisible: boolean = false;
    private perCreditPrice = 0;
    private showPurchaseCreditsModal = false;
    private assignCreditsRequest = {};
    private profileStart = 0;
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private showViewRideCreditModal = false;
    private selectedProfile = {};
    private orgDetails: Organization = null as any;
    private rideCreditActivityDataSource = this.deepClone(RideCreditHistoryDatatable);
    private selectedPatientProfile: RideCreditProfile = null as any;
    private organizationBalance: OrganizationRideCreditBalance = null as any;
    private MathUtils = MathUtils;
    private remainingCreditAmount: string = null as any;
    private showEditProfileModal  = false;
    private profileAddresses: Address[] = [{
        fullAddress: '',
    }];
    private selectedRideCreditProfile: RideCreditProfile = {} as any;
    private isAddressesValid = true;
    private customerPaymentId = '';
    private paymentCustomer: any = '';
    private paymentCustomerId: string = '';
    private showEnableAutoReplenishmentModal = false;
    private logStart = 0;
    private errorMessage = '';

    private async mounted() {
        await this.getOrgDetails();
        this.getRideCreditProfileList('', 0);
    }

    private showCreateProfileModal() {
        this.isCreateProfileModalVisible = true;
    }

    private viewRideCreditModal(profile: any) {
        this.selectedProfile = profile;
        this.showViewRideCreditModal = true;
    }

    private async getRideCreditProfileList(searchString?: string, start?: number) {
        try {
            if (typeof start !== 'undefined') {
                this.profileStart = start;
            } else if (this.profileStart > 0) {
                start = this.profileStart;
            }
            const orgLocations = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
            const locationId = (this.memberProfile.location || {}).id;
            const managedLocationIds = (this.memberProfile.managedLocations || []).map((ml) => ml.id);
            if (this.memberProfile.memberType === 'ORG_MEMBER' && locationId) {
                managedLocationIds.push(locationId);
            }

            const iHttpService = ObjectFactory.getHttpService();
            const queryRecordsRequest: QueryRecordsRequest = {
                    limit: MedTransGoConstants.PAGINATION_LIMIT,
                    conditions: [{
                        fieldName: 'organizationId',
                        op: 'eq',
                        value: this.memberProfile && this.memberProfile.organization ?
                            this.memberProfile.organization.id : '',
                    }],
                    start,
                };
            if (searchString && queryRecordsRequest.conditions) {
                queryRecordsRequest.conditions.push({
                    fieldName: 'patient.fullName',
                    op: 'regex',
                    value: searchString.trim(),
                });
            }
            if (managedLocationIds.length > 0 && queryRecordsRequest.conditions) {
                queryRecordsRequest.conditions.push({
                    fieldName: 'billingLocation',
                    op: 'in',
                    value: managedLocationIds,
                });
            }
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/rideCredit/list`,
                data: queryRecordsRequest,
                loaderEvent : {
                    show: true,
                },
            };
            const response = await iHttpService.post<any>(apiRequest);
            if (response.success && response.data) {
                response.data.forEach((profile: RideCreditProfile) => {
                    if (!profile.creditAmount) {
                        profile.creditAmount = MathUtils.formatCurrency(0) as any;
                    } else  {
                        profile.creditAmount = MathUtils.formatCurrency(profile.creditAmount) as any;
                    }
                    if (!profile.creditPoints) {
                        profile.creditPoints = 0;
                    }
                });
                this.patientCreditDataSource.data = response.data;
            }
            if (response.totalCount) {
                this.patientCreditDataSource.totalCount = response.totalCount;
            }
            if (this.profileStart === 0) {
                this.patientCreditDataSource.page = 1;
            }
        } catch (error) {
            throw error;
        }
    }

    private async getOrgDetails() {
        const response = await ObjectFactory.getOrganizationService().getOrgDetailsById(this.$store.state.serverUrl);
        if (response.success && response.data) {
            if (response.data.rideCreditProgramEnabled) {
                this.show = true;
            }
            if (response.data.rideCreditMethod) {
                if (response.data.rideCreditMethod === 'NO_OF_RIDES') {
                    const option = this.$data.options.find((opt: any) => opt.label === 'Purchase Credit');
                    if (option) {
                        option.label = 'Activity Log';
                    }
                }
                this.patientCreditDataSource = response.data.rideCreditMethod === 'NO_OF_RIDES'
                    ? StandardPatientPassTable : PrePaymentPatientPassTable;
                this.orgDetails = response.data;
                await this.getRideCreditActivityLogs('', 0);
                if (response.data.rideCreditMethod === 'CREDIT_AMOUNT' && response.data.rideCreditDetails) {
                    if (response.data.rideCreditDetails.isAutoReplenishmentEnabled) {
                        this.$data.isAutoReplenishmentEnabled = true;
                    } else {
                        this.$data.isAutoReplenishmentEnabled = false;
                    }
                    this.remainingCreditAmount =
                        MathUtils.formatCurrency(response.data.rideCreditDetails.remainingAmount ?
                            response.data.rideCreditDetails.remainingAmount : 0);
                    this.patientCreditDataSource.columns = this.patientCreditDataSource.columns.map((column: any) => {
                        if (column.label === 'Ride Credits' && column.fieldName === 'creditPoints') {
                            return {
                                ...column,
                                label: 'Credit Amount',
                                fieldName: 'creditAmount',
                            };
                        }
                        return column;
                    });
                    const httpClient = ObjectFactory.getHttpService();
                    const balanceResponse = await httpClient.get<OrganizationRideCreditBalance>({
                        baseURL: this.$store.state.serverUrl,
                        url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${response.data.id}/ride-credit-balance`,
                        loaderEvent: {
                            show: true,
                        },
                    });
                    if (balanceResponse.success && balanceResponse.data) {
                        this.organizationBalance = balanceResponse.data;
                    }
                }
            } else {
                this.$data.showSelectRideCreditMethod = true;
            }
        } else {
            CommonUtils.showError(response);
        }
    }

    private viewPaymentReciept(purchaseHistory: PurchaseHistory) {
        window.open(purchaseHistory.recieptUrl, '_blank');
    }

    private deepClone(obj: any) {
        return JSON.parse(JSON.stringify(obj));
    }

    private viewAssignCreditModal(rideCreditProfile: RideCreditProfile) {
        this.selectedPatientProfile = rideCreditProfile;
        this.$data.showAssignCreditModal = true;
    }

    private async assignRideCredits() {
        const assignRideCreditsRequest: AssignRideCreditRequest = {
            organizationId: this.memberProfile && this.memberProfile.organization ?
                this.memberProfile.organization.id : '',
            creditPoints: parseInt(this.$data.assignCredits, 10),
            profileId: this.selectedPatientProfile.id ? this.selectedPatientProfile.id : '',
        };
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/rideCredit/assign`,
            data: assignRideCreditsRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any>(apiRequest);
        if (response.success) {
            this.errorMessage = '';
            const toastEvent: ToastEvent = {
                message: 'Ride Credit Asssigned Successfully.',
                title: 'Success',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$data.showAssignCreditModal = false;
            await this.getOrgDetails();
            this.getRideCreditProfileList('', this.profileStart);
        } else {
            this.errorMessage = CommonUtils.translateErrorCode(response.errorCode);
            if (!this.errorMessage) {
                this.errorMessage = 'An unknown error occurred.';
            }
        }
        this.$data.assignCredits = 0;
    }

    private viewEditProfileModal(rideCreditProfile: RideCreditProfile) {
        this.selectedRideCreditProfile = rideCreditProfile;
        this.showEditProfileModal = true;
    }

    private addAddress() {
        this.profileAddresses.push({ fullAddress: '' });
        this.$nextTick(() => {
            this.setupGoogleAutocomplete(this.profileAddresses.length - 1);
            this.validateForm();
        });
    }

    private removeAddress(index: number) {
        if (this.profileAddresses && this.profileAddresses.length > 1) {
            this.profileAddresses.splice(index, 1);
            this.validateForm();
        }
    }

    private setupGoogleAutocomplete(index: number) {
        this.$nextTick(() => {
            const inputId = `patientAddress_${index}`;
            const inputElement = document.getElementById(inputId);
            if (inputElement) {
                const autocomplete = new google.maps.places.Autocomplete(inputElement, { types: ['geocode'] });
                autocomplete.addListener('place_changed', () => {
                    this.profileAddresses[index] = MapUtils.parseGoogleAddress(autocomplete);
                    this.validateForm();
                });
            }
        });
    }

    private checkAddressesValid() {
        if (this.profileAddresses && this.profileAddresses.length > 0) {
            this.profileAddresses.forEach((address: Address) => {
                if (!address.fullAddress || !address.zip) {
                    this.isAddressesValid = false;
                    return;
                }
            });
        } else {
            this.isAddressesValid = false;
        }
    }

    private validateForm() {
        let isAddressEntered = true;
        this.profileAddresses.forEach((address: Address) => {
            if (!address.fullAddress || !address.zip || !address.latitude || !address.longitude) {
                isAddressEntered = false;
                return;
            }
        });
        this.isAddressesValid =  isAddressEntered;
    }

    private selectCreditMethod(rideCreditMethod: RideCreditMethod) {
        this.$data.selectedRideCreditMethod = rideCreditMethod;
    }

    private async selectRideCreditMethod(rideCreditMethod: RideCreditMethod) {
        const iHttpService = ObjectFactory.getHttpService();
        const updateOrgRequest: UpdateOrgRequest = {
            rideCreditMethod,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${this.orgDetails ? this.orgDetails.id : this.memberProfile && this.memberProfile.organization ? this.memberProfile.organization.id : ''}/update`,
            data: updateOrgRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<Organization>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: `Ride Credit Method Selected Successfully`,
                title: 'Success!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$data.showSelectRideCreditMethod = false;
            await this.getOrgDetails();
        } else {
            CommonUtils.showError(response);
        }
    }

    private closeSelectRideCreditModal() {
        this.$data.showSelectRideCreditMethod = false;
        this.$router.replace('/requests');
    }

    private toggleAutoReplenishment() {
        const updatedValue = !this.$data.isAutoReplenishmentEnabled;
        if (updatedValue) {
            this.getPaymentCustomer();
            this.showEnableAutoReplenishmentModal = true;
        } else {
            this.$data.showDisableReplenishmentConfirmation = true;
        }
    }

    private async getPaymentCustomer() {
        if (!this.customerPaymentId) {
            const memberResponse = await ObjectFactory.getMemberService().
                    getMemberDetails(this.$store.state.serverUrl, this.memberProfile.memberId);
            if (memberResponse.success && memberResponse.data && memberResponse.data.paymentCustomerId) {
                this.customerPaymentId = memberResponse.data.paymentCustomerId;
                this.paymentCustomerId = memberResponse.data.paymentCustomerId;
            } else {
                this.paymentCustomer = '';
                return;
            }
        }
        const response = await ObjectFactory.getPaymentSourceService()
            .getPaymentCustomer(this.$store.state.serverUrl, this.customerPaymentId);
        this.paymentCustomer = response.data;
    }

    get isEnableReplenishmentModalValid() {
        if (!this.$data.replenishmentThreshold || this.$data.replenishmentThreshold <= 0
                || !this.$data.replenishmentAmount || this.$data.replenishmentAmount <= 0 ||
                !this.paymentCustomer.defaultSource.id) {
            return false;
        } else {
            return true;
        }
    }

    private async enableDisableAutoReplenishment(enable: boolean) {
        const updateOrgRequest: UpdateOrgRequest = {};
        let organizationId = '';
        if (this.memberProfile && this.memberProfile.organization) {
            organizationId = this.memberProfile.organization.id;
        } else if (this.orgDetails.id) {
            organizationId = this.orgDetails.id;
        }
        if (enable) {
            updateOrgRequest.isAutoReplenishmentEnabled = true;
            updateOrgRequest.replenishmentAmount = this.$data.replenishmentAmount * 100;
            updateOrgRequest.replenishmentPaymentSource = this.paymentCustomer.defaultSource.id;
            updateOrgRequest.replenishmentThreshold = this.$data.replenishmentThreshold * 100;
        } else {
            updateOrgRequest.isAutoReplenishmentEnabled = false;
        }
        const updateResponse = await ObjectFactory.getOrganizationService().updateOrganization
                (this.$store.state.serverUrl, organizationId, updateOrgRequest);
        this.$data.showDisableReplenishmentConfirmation = false;
        this.$data.replenishmentThreshold = null;
        this.$data.replenishmentAmount = null;
        if (updateResponse.success) {
            this.$data.enableAotoReplanizhmentError = '';
            this.showEnableAutoReplenishmentModal = false;
            const toastEvent: ToastEvent = {
                message: `Auto Replenishment ${enable ? `Enabled` : `Disabled`}Successfully`,
                title: 'Success!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$data.showSelectRideCreditMethod = false;
            await this.getOrgDetails();
        } else {
            this.$data.enableAotoReplanizhmentError = CommonUtils.translateErrorCode(updateResponse.errorCode);
        }
    }

    private async closeProfile(rideCreditprofile: RideCreditProfile) {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_PATIENTS}/${rideCreditprofile.id}/rideCredit/close`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<any>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: `Ride Credit Method Closed Successfully`,
                title: 'Success!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            await this.getOrgDetails();
        } else {
            CommonUtils.showError(response);
        }
    }

    private async getRideCreditActivityLogs(searchString?: string, start?: number) {
        try {
            if (typeof start !== 'undefined') {
                this.logStart = start;
            } else if (this.logStart > 0) {
                start = this.logStart;
            }
            const iHttpService = ObjectFactory.getHttpService();
            const organizationId = this.memberProfile && this.memberProfile.organization ?
                        this.memberProfile.organization.id : '';
            const queryRecordsRequest: QueryRecordsRequest = {
                limit: MedTransGoConstants.PAGINATION_LIMIT,
                conditions: [],
                start,
            };
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${organizationId}/ride-credit-logs`,
                data: queryRecordsRequest,
                loaderEvent : {
                    show: true,
                },
            };
            const response = await iHttpService.post<any>(apiRequest);
            if (response.success && response.data) {
                this.rideCreditActivityDataSource.data = response.data;
            }
            if (response.totalCount) {
                this.rideCreditActivityDataSource.totalCount = response.totalCount;
            }
        } catch (error) {
            throw error;
        }
    }

}
